import { tv } from 'tailwind-variants'

export const infoMessageIconVariants = tv({
  slots: {
    container: 'flex items-center justify-center'
  },
  variants: {
    status: {
      SENT: {
        container: 'text-primary-medium'
      },
      SENDING: {
        container: 'text-primary-medium'
      },
      DELIVERED: {
        container: 'text-secondary-medium'
      },
      READ: {
        container: 'text-success-medium'
      },
      NOT_DELIVERED: {
        container: 'text-error-medium'
      },
      REJECTED: {
        container: 'text-error-medium'
      },
      FAILED: {
        container: 'text-error-medium'
      },
      ERROR: {
        container: 'text-error-medium'
      }
    }
  }
})
